// IPhone XS and XR
export const IPHONE_X_OR_XS_WIDTH = 375;
export const IPHONE_X_OR_XS_HEIGHT = 812;
export const IPHONE_XS_MAX_OR_XR_WIDTH = 414;
export const IPHONE_XS_MAX_OR_XR_HEIGHT = 896;

// IPhone 12
export const IPHONE_12_WIDTH = 390;
export const IPHONE_12_HEIGHT = 844;
export const IPHONE_12_PRO_MAX_WIDTH = 428;
export const IPHONE_12_PRO_MAX_HEIGHT = 926;

// IPhone 13
export const IPHONE_13_WIDTH = 390;
export const IPHONE_13_HEIGHT = 844;
export const IPHONE_13_MINI_WIDTH = 375;
export const IPHONE_13_MINI_HEIGHT = 812;
export const IPHONE_13_PRO_MAX_WIDTH = 428;
export const IPHONE_13_PRO_MAX_HEIGHT = 926;

// IPhone 14
export const IPHONE_14_HEIGHT = 844;
export const IPHONE_14_HEIGHT_WIDTH = 390;
export const IPHONE_14_PLUS_HEIGHT = 926;
export const IPHONE_14_PLUS_WIDTH = 428;
export const IPHONE_14_PRO_HEIGHT = 852;
export const IPHONE_14_PRO_WIDTH = 393;
export const IPHONE_14_PRO_MAX_HEIGHT = 932;
export const IPHONE_14_PRO_MAX_WIDTH = 430;

export function isMobile(): boolean {
  const toMatch = [/webOS/i, /Android/i, /BlackBerry/i, /Windows Phone/i];

  const isMobile = toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });

  return isMobile || isIosDevice();
}

export function isIosDevice(): boolean {
  const toMatch = [
    /iPad/i,
    /iPod/i,
    /iPhone/i,
    /iPad Simulator/i,
    /iPod Simulator/i,
    /iPhone Simulator/i,
  ];

  return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
}

export function isIPhoneX() {
  const ratio = window.devicePixelRatio ?? 1;

  const screen = {
    width: window.screen.width * ratio,
    height: window.screen.height * ratio,
  };
  const isIPhoneX =
    screen.width === IPHONE_X_OR_XS_WIDTH && screen.height === IPHONE_X_OR_XS_HEIGHT;
  const isIPhoneXMax =
    screen.width === IPHONE_XS_MAX_OR_XR_WIDTH && screen.height === IPHONE_XS_MAX_OR_XR_HEIGHT;
  const isIPhone12 = IPHONE_12_WIDTH === screen.width && IPHONE_12_HEIGHT === screen.height;
  const isIPhone12Pro =
    IPHONE_12_PRO_MAX_WIDTH === screen.width && IPHONE_12_PRO_MAX_HEIGHT === screen.height;

  const isIPhone13 = IPHONE_13_WIDTH === screen.width && IPHONE_13_HEIGHT === screen.height;
  const isIPhone13Mini =
    IPHONE_13_MINI_WIDTH === screen.width && IPHONE_13_MINI_HEIGHT === screen.height;
  const isIPhone13Pro =
    IPHONE_13_PRO_MAX_WIDTH === screen.width && IPHONE_13_PRO_MAX_HEIGHT === screen.height;

  const isIPhone14 = IPHONE_14_HEIGHT_WIDTH === screen.width && IPHONE_14_HEIGHT === screen.height;
  const isIPhone14Plus =
    IPHONE_14_PLUS_WIDTH === screen.width && IPHONE_14_PLUS_HEIGHT === screen.height;
  const isIPhone14Pro =
    IPHONE_14_PRO_WIDTH === screen.width && IPHONE_14_PRO_HEIGHT === screen.height;
  const isIPhone14ProMax =
    IPHONE_14_PRO_MAX_WIDTH === screen.width && IPHONE_14_PRO_MAX_HEIGHT === screen.height;

  return (
    isIPhoneX ||
    isIPhone12 ||
    isIPhone13 ||
    isIPhone14 ||
    isIPhoneXMax ||
    isIPhone12Pro ||
    isIPhone14Pro ||
    isIPhone13Pro ||
    isIPhone13Mini ||
    isIPhone14Plus ||
    isIPhone14ProMax
  );
}

export function isFirefox(): boolean {
  return /Firefox/i.test(navigator.userAgent);
}

export function isChrome(): boolean {
  // Chrome check excludes other Chromium-based browsers
  return /Chrome/i.test(navigator.userAgent) && !/Edge|Edg|OPR|Opera/i.test(navigator.userAgent);
}

export function getBrowserType(): "firefox" | "chrome" | "other" {
  if (isFirefox()) return "firefox";
  if (isChrome()) return "chrome";
  return "other";
}

export function applyBrowserClassToBody(): void {
  const browserType = getBrowserType();
  const body = document.body;

  // Remove any existing browser classes
  body.classList.remove("browser-firefox", "browser-chrome", "browser-other");

  // Add the current browser class
  body.classList.add(`browser-${browserType}`);
}
